import React from 'react'

const Menu = props => (
	<svg width={48} height={48} viewBox="0 0 48 48" {...props}>
		<path d="M0 0h48v48H0z" fill="none" />
		<path d="M6 36h36v-4H6v4zm0-10h36v-4H6v4zm0-14v4h36v-4H6z" fill="#fff" />
	</svg>
)

export default Menu



// WEBPACK FOOTER //
// ./src/components/Layout/nav/MobileNav/IconMenu.js